var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('IxVectorLayer',{attrs:{"features":_vm.features,"vector-style":_vm.style,"z-index":1,"layer-id":"soilMap","auto-focus":_vm.autoFocus}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }